import { CreativeExtension } from '@lib/iab/iab-vast-model';

interface ICreativeExtension {
    type: string;
    _value: Element;
}

const createCreativeExtension = (
    $creativeExtension: ICreativeExtension
): CreativeExtension => {
    const creativeExtension = new CreativeExtension();
    creativeExtension.type = $creativeExtension.type;
    creativeExtension.xmlElement = $creativeExtension._value;
    return creativeExtension;
};

export default createCreativeExtension;
